import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useLang } from '../lib/i18n';
import { PRIVACY, TERMS, COOKIES, DOC_META } from '../lib/legal';

const DOCS = { privacy: PRIVACY, terms: TERMS, cookies: COOKIES };
const LINK_DOCS = ['privacy', 'terms', 'cookies'];

// Legal page: one component for the three documents, bilingual via LangContext.
const LegalDoc = ({ doc }) => {
    const lang = useLang();
    const ru = lang === 'ru';
    const meta = DOC_META[doc];
    const content = DOCS[doc][ru ? 'ru' : 'ro'];
    const curPath = ru ? meta.ruPath : meta.roPath;

    const links = LINK_DOCS.map((d) => {
        const m = DOC_META[d];
        return { to: ru ? m.ruPath : m.roPath, label: ru ? m.ruH1 : m.roH1, active: d === doc };
    });

    return (
        <>
            <Helmet>
                <title>{ru ? meta.ruTitle : meta.roTitle}</title>
                <meta name="description" content={ru ? meta.ruDesc : meta.roDesc} />
                <link rel="canonical" href={`https://lvgimob.md${curPath}`} />
                <link rel="alternate" hreflang="ro" href={`https://lvgimob.md${meta.roPath}`} />
                <link rel="alternate" hreflang="ru" href={`https://lvgimob.md${meta.ruPath}`} />
                <link rel="alternate" hreflang="x-default" href={`https://lvgimob.md${meta.roPath}`} />
            </Helmet>

            <section className='py-[60px] sm:py-[80px] px-[12px] flex flex-col gap-[20px] sm:container sm:mx-auto' style={{ minHeight: "calc(100vh - 88px - 561px)" }}>
                <h1 className="text-[22px] font-poppins font-[500] sm:text-[26px]">{ru ? meta.ruH1 : meta.roH1}</h1>

                <div className="flex flex-wrap gap-[8px] text-[13.5px] font-body mb-[10px]">
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            className={`border-[1px] rounded-[5px] px-[13px] py-[6px] ${l.active ? 'bg-[#181616] !border-[#181616] text-white' : 'border-gray-300 text-[#181616] hover:bg-gray-200'} transition-all duration-100 ease-in`}
                        >
                            {l.label}
                        </Link>
                    ))}
                </div>

                <div className="flex flex-col gap-[28px] max-w-[900px]">
                    {content.map((section, idx) => (
                        <div key={idx} className="flex flex-col gap-[10px]">
                            <h2 className="text-[18px] font-poppins font-[500] sm:text-[20px]">{section.h}</h2>
                            {section.p.map((paragraph, pIdx) => (
                                <p key={pIdx} className="text-[14.5px] font-body text-gray-700 leading-[1.7]">{paragraph}</p>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default LegalDoc;
